import { mergeActionDefinitions } from "../../../utils";

export default mergeActionDefinitions("Users", {
  exportAttemptsAnalytics: [
    "courseDisplayName",
    "objectDisplayName",
    "selectedUnitName",
    "content",
    "attemptsAnalytics",
    "masterLocale",
  ],
  exportUsers: ["users", "usersAnalytics", "objectDisplayName", "courseDisplayName", "isXLSX"],
});
